module.exports = __webpack_public_path__ + "static/media/imageIcon.26584143.jpg";